var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,0h0a50,50,0,0,1,50,50h0a50,50,0,0,1-50,50h0A50,50,0,0,1,0,50H0A50,50,0,0,1,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,2.5h0A47.5,47.5,0,0,1,97.5,50h0A47.5,47.5,0,0,1,50,97.5h0A47.5,47.5,0,0,1,2.5,50h0A47.5,47.5,0,0,1,50,2.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-1",
    d: "M65.78,31.08h0a3.53,3.53,0,1,0,3.54,3.52v0a3.5,3.5,0,0,0-3.51-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-3",
    d: "M61.93,20H38.07A18.07,18.07,0,0,0,20,38.08V61.94A18.08,18.08,0,0,0,38.07,80H61.93A18.08,18.08,0,0,0,80,61.94h0V38.09A18.07,18.07,0,0,0,61.93,20ZM50.1,65.21a14.82,14.82,0,0,1,0-29.63h0a14.81,14.81,0,1,1,0,29.61h0ZM65.79,38.13a3.53,3.53,0,0,1,0-7.05h0a3.53,3.53,0,0,1,0,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-3",
    d: "M50.1,40.89a9.5,9.5,0,0,0,0,19h0a9.5,9.5,0,0,0,0-19Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1c1d6f4516377b9b9091a0ab5fd50c2c.svg";
export { ForwardRef as ReactComponent };